import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const getDialCodeFromCountryCode = (countryCode: string): string =>
  phoneUtil.getCountryCodeForRegion(countryCode.toUpperCase()).toString();
